import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorModel } from './error-model';
import { Constants } from './constants';
import { Login } from './login.model';
import { APIConstants } from './apiconstants';
import { AuthModel } from './auth-model';

declare var $: any;

export interface ICustomerWindow extends Window {
  __customer_global_stuff: string;
}

function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root'
})

export class BaseService {
  get netiveWindow(): ICustomerWindow {
    return getWindow();
  }

  public setmenu: boolean = false;
  public epmplytype: boolean = false;
  public inventorytype: boolean = false;
  public IsUserLoggedIn: boolean = false;
  public header: boolean = false;
  public UserProfile: any = [];
  public loading: boolean = false;
  public images: string = '';
  public sulg: any;
  public proimag: any = [];
  public control: any = [];
  public img_url: any = [];
  public roles: any = [];
  public type: any = [];
  public freeplan: boolean = false;
  public salg: any = [];
  public Invoiceview: boolean = false;
  public invoicelength: any = 0;
  public invoiceId: any = 0;
  // public baseurl: string = 'http://localhost:2000/api';
  public baseurl: string = 'https://vasavisahyog.com:2000/api';
  public image_url: string = 'https://vasavibk.s3.dualstack.eu-north-1.amazonaws.com/';
  public pdf_url: string = 'https://vasavibk.s3.dualstack.eu-north-1.amazonaws.com/';
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {

  }

  public Get(routePath: string) {
    return this.http.get<any>(this.baseurl + routePath, this.getHeader());

  }

  public GetImage(routePath: string) {
    return this.http.get<any>(this.baseurl + routePath, this.getHeader());

  }

  public Post(routePath: string, data: any) {
    return this.http.post<any>(this.baseurl + routePath, data, this.getHeader())
  }

  public GetAuth(routePath: string) {
    return this.http.get<any>(this.baseurl + routePath, this.getHeader(true));
  }

  // Auth GET for binary responses (e.g. PDF download)
  public GetAuthBlob(routePath: string) {
    const options: any = this.getHeader(true);
    options.responseType = 'blob';
    return this.http.get(this.baseurl + routePath, options);
  }

  public PostAuth(routePath: string, data: any) {
    var datav = this.http.post<any>(this.baseurl + routePath, data, this.getHeader(true))
    return datav;
  }

  public PutAuth(routePath: string, data: any) {
    return this.http.put<any>(this.baseurl + routePath, data, this.getHeader(true))
  }

  public Delete(routePath: string) {
    return this.http.delete<any>(this.baseurl + routePath, this.getHeader(true))
  }

  Postimg(API: string, body: any) {
    const formData: FormData = new FormData();
    var file = body[0];
    formData.append('file', file, file.name);

    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     //"Authorization": 'Bearer ' + this.GetAuthToken(),
    //     'Content-Type': 'application/json'
    //   })
    // };

    return this.http.post(this.baseurl + '/' + API, formData)
  }

  // PDF upload with auth (doesn't set Content-Type to let browser set it with boundary)
  PostAuthPdf(routePath: string, formData: FormData) {
    const token = this.GetAuthToken();
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
      // Don't set Content-Type - let browser set it with boundary for multipart/form-data
    });
    return this.http.post<any>(this.baseurl + routePath, formData, { headers: headers });
  }

  public Login(lModel: Login) {
    var data = { "email": lModel.email, "mobile": lModel.mobile, "password": lModel.password, "type": lModel.type }
    var loginHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(this.baseurl + APIConstants.Login, data, { headers: loginHeader });
  }

  public Logout() {
    this.IsUserLoggedIn = false;
    localStorage.clear();
    this.router.navigate(['/']);
  }

  public GetAuthToken() {
    const currentUser = this.GetLoggedInUser();
    if (currentUser != null) {
      this.sulg = currentUser;
      return currentUser;
    }
    else {
      return null;
    }
  }

  public GetLoggedInUser() {
    this.IsUserLoggedIn = false;
    try {
      const authDataString = localStorage.getItem(Constants.AuthData);
      if (!authDataString || authDataString === 'undefined' || authDataString === 'null') {
        return null;
      }
      var currentUser: AuthModel = JSON.parse(authDataString);

      if (currentUser !== null && Object.keys(currentUser).length > 0) {
        this.IsUserLoggedIn = true;
        return currentUser;
      }
      else {
        if (!this.IsUserLoggedIn) {
          this.Logout();
        }
        return null;
      }
    } catch (error) {
      console.error('Error parsing auth data from localStorage:', error);
      localStorage.removeItem(Constants.AuthData);
      this.IsUserLoggedIn = false;
      this.Logout();
      return null;
    }
  }



  private getHeader(isAuth: boolean = false) {
    var reqHeader: any;
    var token = this.GetAuthToken();
    if (isAuth) {
      reqHeader = new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      );
    }
    else {
      reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    return { headers: reqHeader };
  }

  setdate(date: any) {
    var d = new Date(date);
    var month = (d.getMonth() + 1).toString();
    var day = (d.getDate()).toString();
    var year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    var datedata = year + "-" + month + "-" + day;
    return datedata;
  }

  // Schedule Call API
  createScheduleCall(scheduleData: any) {
    return this.PostAuth(this.baseurl + '/schedule-call/create', scheduleData);
  }

  // Get current user ID from localStorage
  getCurrentUserId(): number | null {
    try {
      const authData = localStorage.getItem('AuthData');
      if (!authData || authData === 'undefined' || authData === 'null') {
        return null;
      }
      const userData = JSON.parse(authData);
      const id = (userData && (userData.user_id ?? userData.id)) ?? null;
      return typeof id === 'number' ? id : (id ? Number(id) : null);
    } catch (error) {
      console.error('Error parsing user ID from localStorage:', error);
      return null;
    }
  }

  // Get current user details from backend (validate-token)
  getCurrentUserDetails() {
    return this.GetAuth('/user/validate-token');
  }

   // Get current user ID by calling /user/validate-token (async)
   // Usage: this.baseService.getCurrentUserIdFromApi().subscribe(id => { ... });
   getCurrentUserIdFromApi() {
    return this.GetAuth('/user/validate-token').pipe(
      map((res: any) => res?.data?.user?.user_id || res?.data?.user?.id || null),
      catchError((error) => {
        console.error('Failed to fetch current user via validate-token:', error);
        return of(null);
      })
    );
  }

  // Check payment status using verify API:
  // GET /api/payment/verify/:orderId?schedule_id=...&user_id=...
  checkPaymentStatus(orderId: string | number, scheduleId?: string | number, userId?: string | number) {
    const resolvedUserId = userId || this.getCurrentUserId();
    const resolvedScheduleId = scheduleId || orderId;

    const orderIdStr = String(orderId);
    const scheduleIdStr = String(resolvedScheduleId);
    const userIdStr = resolvedUserId ? String(resolvedUserId) : '';

    const query = `?schedule_id=${encodeURIComponent(scheduleIdStr)}${userIdStr ? `&user_id=${encodeURIComponent(userIdStr)}` : ''}`;

    return this.GetAuth(`/payment/verify/${encodeURIComponent(orderIdStr)}${query}`);
  }

  // Verify payment status from redirect parameters
  verifyPaymentFromRedirect(redirectParams: any) {
    return this.PostAuth('/payment/verify-redirect', redirectParams);
  }

}